export default __webpack_public_path__ + "69160857ec6d6f04de534217b5d71ab0.svg";